export function getDocumentsById(state) {
  return state.admin.documents;
}
